export var PACKAGE_SOURCE = "components";
export var PACKAGE_VERSION = "3.0.0 (f492b46a)";
export var THEME = "open-source-visual-refresh";
export var ALWAYS_VISUAL_REFRESH = true;